<template>
  <v-card :class="['pt-0']">
    <v-card-title :class="['pa-3']">
      <v-text-field :class="['pt-0', 'mt-0']" v-model="search" append-icon="search" :label="lang.search" single-line hide-details :color="$root.colors.primary" />
      <v-btn dark @click="exportData" :color="$root.colors.primary" small :title="lang.exportToCsv" :class="['mt-2', 'hidden-xs-only', 'ml-4']">
        <v-icon>mdi-file-excel-box</v-icon><span v-html="lang.exportToCsv" :class="['ml-1']" />
      </v-btn>
    </v-card-title>
    <v-data-table :no-data-text="lang.noDataAvailable" :pagination.sync="pagination" :headers="headers" :class="['elevation-1']" :items="items" :items-per-page="itemsPerPage" :search="search">
      <template v-slot:items="props">
        <tr ripple @click="goToResource('/bands', props.item.id)" :class="['item-clickable']" :title="lang.moreInfo">
          <td v-html="props.item.id" :class="['hidden-sm-and-down']" />
          <td v-html="props.item.name" />
          <td v-html="props.item.genre" :class="['hidden-xs-only']" />
          <td v-html="props.item.region" />
          <td v-html="props.item.created" :class="['hidden-sm-and-down']" />
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'
import Papa from 'papaparse'
import { saveAs } from 'file-saver'

export default {
  name: 'Grid',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      search: '',
      pagination: {
        rowsPerPage: this.$root.config.gridRowsPerPage,
        sortBy: 'id'
      }
    }
  },
  props: {
    /**
     * Grid headers
     * @array
     */
    headers: {
      type: Array,
      default: () => {
        return []
      }
    },
    /**
     * Grid items
     * @array
     */
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    /**
     * Items per page shown by default
     * @number
     */
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10
    }
  },
  methods: {
    /**
     * Export the grid data as a csv file
     * @method exportData
     * @return {void}
     */
    exportData () {
      const blob = new Blob([Papa.unparse(this.items)], {type: 'text/csv;charset=utf-8'})
      const title = document.title.replace(/\s\|\s|\/|\s/g, '-').toLowerCase()
      saveAs(blob, `${title}.csv`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/grid.vue